import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const ChevronLeft = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          ref={ref}
          {...props}
        >
          <path
            d="M13.8926 2L6.10879 9.7838L13.8926 18"
            stroke="currentcolor"
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

ChevronLeft.displayName = "ChevronLeft";
